<template>
  <div class="dashboard-heading" :class="{'hidden' : isLoading || !isLoggedIn}">
    <h1>{{ $t('PersonalData') }}</h1>
  </div>
  <div class="personal-section" :class="{'hidden' : isLoading || !isLoggedIn}">
    <div class="personal-section__header" @click="openCloseDetails(1)">
      <img class="personal-section__header__icon" :src="logoUser" alt="logo user"/>
      <div class="personal-section__header__label">{{ $t('PersonalData') }}</div>
      <img class="personal-section__header__chevron"
           :src="isOpenedDetails(1) ? logoChevronUp : logoChevronDown" alt="chevron"/>
    </div>
    <div class="personal-section__body" :class="{'hidden' : !isOpenedDetails(1)}">
      <div class="col-lg-12">
        <form @submit.prevent="onSubmitPersonalData" autocomplete="off">
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label for="first_name" class="form-label">{{ $t('FirstName') }}</label>
              <input v-model="first_name" type="text"
                     name="first_name"
                     class="form-control input-dirty"
                     placeholder=""
                     id="first_name"
                     aria-describedby="first_name"
                     autocomplete="off"
              >
              <div class="form-text" :class="isFirstNameInvalid ? 'color-alert' : ''">{{ firstNameMsg }}</div>
            </div>
            <div class="col-lg-6 mb-3">
              <label for="last_name" class="form-label">{{ $t('LastName') }}</label>
              <input v-model="last_name" type="text"
                     name="last_name"
                     class="form-control input-dirty"
                     placeholder=""
                     id="last_name"
                     aria-describedby="last_name"
                     autocomplete="off"
              >
              <div class="form-text" :class="isLastNameInvalid ? 'color-alert' : ''">{{ lastNameMsg }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label for="phone" class="form-label">{{ $t('Phone') }}</label>
              <template v-if="currentUser">
                <label v-if="!currentUser.is_verified_phone && currentUser.phone" for="phone" class="form-label color-alert pl-15">
                  {{ $t('PleaseVerifyYourPhoneNumber') }} <router-link :to="{name: 'register'}">{{ $t('here') }}</router-link>
                </label>
              </template>
              <input v-model="phone"
                     type="text"
                     name="phone"
                     class="form-control input-dirty"
                     placeholder="+38 (___) ___-__-__"
                     id="phone"
                     aria-describedby="phone"
                     autocomplete="unique-key-for-off-autocomlete-123ew2"
              >
              <div class="form-text" :class="isPhoneInvalid ? 'color-alert' : ''">{{ phoneMsg }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label for="email" class="form-label">{{ $t('Email') }}</label>
              <template v-if="currentUser">
                <label v-if="!currentUser.is_verified_email && currentUser.email && isEmailSaved" for="email" class="form-label color-alert pl-15">
                  {{ $t('PleaseVerifyYourEmail') }} <router-link :to="{name: 'emailVerification'}">{{ $t('here') }}</router-link>
                </label>
              </template>
              <input v-model="email"
                     @input="onEmailChanged"
                     type="text"
                     name="email"
                     class="form-control input-dirty"
                     placeholder=""
                     id="email"
                     aria-describedby="email"
                     autocomplete="unique-key-for-off-autocomlete-123ew3"
              >
              <div class="form-text" :class="isEmailInvalid ? 'color-alert' : ''">{{ emailMsg }}</div>
            </div>
          </div>
          <div class="mt-4">
            <button class="btn btn-success" :disabled="!isCurrentUserChanged">{{ $t('Save') }}</button>
            <button @click="restoreCurrentUserData" type="button"
                    class="btn btn-secondary" :disabled="!isCurrentUserChanged">{{ $t('Cancel') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="personal-section" :class="{'hidden' : isLoading || !isLoggedIn}">
    <div class="personal-section__header" @click="openCloseDetails(2)">
      <img class="personal-section__header__icon" :src="logoLock" alt="logo lock"/>
      <div class="personal-section__header__label">{{ $t('Security') }}</div>
      <img class="personal-section__header__chevron"
           :src="isOpenedDetails(2) ? logoChevronUp : logoChevronDown" alt="chevron"/>
    </div>
    <div class="personal-section__body" :class="{'hidden' : !isOpenedDetails(2)}">
      <div class="col-lg-12">
        <form @submit.prevent="onSubmitSetPassword" autocomplete="off">
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label for="password" class="form-label">{{ $t('NewPassword') }}</label>
              <input v-model="password" type="password"
                     name="password"
                     class="form-control input-dirty"
                     placeholder=""
                     id="password"
                     aria-describedby="password"
              >
              <div class="form-text" :class="isPasswordInvalid ? 'color-alert' : ''">{{ passwordMsg }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label for="password_confirm" class="form-label">{{ $t('ConfirmPassword') }}</label>
              <input v-model="password_confirm" type="password"
                     name="password_confirm"
                     class="form-control input-dirty"
                     placeholder=""
                     id="password_confirm"
                     aria-describedby="password_confirm"
              >
              <div class="form-text" :class="isPasswordInvalid ? 'color-alert' : ''">{{ passwordMsg }}</div>
            </div>
          </div>
          <div class="mt-4">
            <button class="btn btn-success" :disabled="!password && !password_confirm">{{ $t('Save') }}</button>
            <button type="button"
                    class="btn btn-secondary" :disabled="!password && !password_confirm">{{ $t('Cancel') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="personal-section" :class="{'hidden' : isLoading || !isLoggedIn}">
    <div class="personal-section__header" @click="openCloseDetails(3)">
      <img class="personal-section__header__icon" :src="logoGear" alt="logo gear"/>
      <div class="personal-section__header__label">{{ $t('Setting') }}</div>
      <img class="personal-section__header__chevron"
           :src="isOpenedDetails(3) ? logoChevronUp : logoChevronDown" alt="chevron"/>
    </div>
    <div class="personal-section__body" :class="{'hidden' : !isOpenedDetails(3)}">
      <div class="col-lg-12">
        <form @submit.prevent="onSubmitLanguage" autocomplete="off">
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label for="language" class="form-label">{{ $t('Language') }}</label>
              <select class="form-select" v-model="language">
                <option disabled selected value="">{{ $t('SelectLanguage') }}</option>
                <option value="uk">{{ $t('Ukrainian') }}</option>
                <option value="ru">{{ $t('Russian') }}</option>
              </select>
            </div>
          </div>
          <div class="mt-4">
            <button class="btn btn-success">{{ $t('Save') }}</button>
            <button type="button"
                    class="btn btn-secondary">{{ $t('Cancel') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="personal-section" :class="{'hidden' : isLoading || !isLoggedIn}">
    <div class="personal-section__header" @click="openCloseDetails(4)">
      <img class="personal-section__header__icon" :src="logoPostcard" alt="logo postcard"/>
      <div class="personal-section__header__label">{{ $t('MyOrderRecipients') }}</div>
      <img class="personal-section__header__chevron"
           :src="isOpenedDetails(4) ? logoChevronUp : logoChevronDown" alt="chevron"/>
    </div>
    <div class="personal-section__body" :class="{'hidden' : !isOpenedDetails(4)}">
      <div v-if="isOpenedDetails(4)" class="col-lg-12">
        <dashboard-recipients/>
      </div>
    </div>
  </div>
  <div class="personal-section" :class="{'hidden' : isLoading || !isLoggedIn}">
    <div class="personal-section__header" @click="openCloseDetails(5)">
      <img class="personal-section__header__icon" :src="logoTruck" alt="logo truck"/>
      <div class="personal-section__header__label">{{ $t('DeliveryAddress') }}</div>
      <img class="personal-section__header__chevron"
           :src="isOpenedDetails(5) ? logoChevronUp : logoChevronDown" alt="chevron"/>
    </div>
    <div class="personal-section__body" :class="{'hidden' : !isOpenedDetails(5)}">
      <div v-if="isOpenedDetails(5)" class="col-lg-12">
        <dashboard-address/>
      </div>
    </div>
  </div>
  <template v-if="isLoading">
    <dashboard-address/>
  </template>
</template>

<script>
import DashboardRecipients from "@/components/Recipients.vue";
import DashboardAddress from "@/components/Address.vue";
import {mapGetters} from "vuex";
import {getterTypes, mutationTypes, actionTypes} from "@/store/modules/auth";
import Inputmask from "inputmask"
import {phoneCleanForSet} from "@/helpers/phone";
import {getItem, setItem} from "@/helpers/persistanceStorage";


export default {
  name: 'DashboardProfileSettings',
  components: {
    DashboardRecipients,
    DashboardAddress,
  },
  data(){
    return {
      logoUser: require('@/assets/svg/person-circle.svg'),
      logoChevronUp: require('@/assets/svg/chevron-compact-up.svg'),
      logoChevronDown: require('@/assets/svg/chevron-compact-down.svg'),
      logoLock: require('@/assets/svg/shield-lock.svg'),
      logoGear: require('@/assets/svg/gear.svg'),
      logoPostcard: require('@/assets/svg/postcard.svg'),
      logoTruck: require('@/assets/svg/truck.svg'),
      openedDetails: [],
      isCurrentUserChanged: false,
      firstNameMsg: '',
      isFirstNameInvalid: false,
      lastNameMsg: '',
      isLastNameInvalid: false,
      phoneMsg: '',
      isPhoneInvalid: false,
      emailMsg: '',
      isEmailInvalid: false,
      isEmailSaved: false,
      passwordMsg: '',
      password: '',
      isPasswordInvalid: false,
      password_confirm: '',
      language: ''
    }
  },
  mounted() {
    this.$nextTick(function () {
      let phoneSelector = document.getElementById("phone");
      if (JSON.stringify(phoneSelector) !== "null"){
        let maskPhone = new Inputmask({ mask: "+38 (999) 999-99-99", greedy: false})
        maskPhone.mask(phoneSelector)
      }
    })
    this.language = this.lang;
    if (this.$route.query.opened_details){
      this.openedDetails.push(parseInt(this.$route.query.opened_details))
      this.testNotification(
          'warn',
          this.$t('PersonalData'),
          this.$t('FillInYourPersonalDataOnThisPage')
      )
    }
  },
  methods: {
    openCloseDetails(listId) {
      const found = this.openedDetails.find((element) => element === listId);
      if (found){
        const index = this.openedDetails.indexOf(listId);
        delete this.openedDetails[index]
      } else {
        this.openedDetails.push(listId)
      }
    },
    isOpenedDetails(listId){
      return this.openedDetails.find((element) => element === listId)
    },
    clearPersonalDataForm() {
      this.firstNameMsg = ''
      this.isFirstNameInvalid = false
      this.lastNameMsg = ''
      this.isLastNameInvalid = false
      this.phoneMsg = ''
      this.isPhoneInvalid = false
      this.emailMsg = ''
      this.isEmailInvalid = false
    },
    onSubmitPersonalData() {
      this.clearPersonalDataForm()

      this.$store
          .dispatch(actionTypes.updateCurrentUser, {
            first_name: this.currentUser.first_name,
            last_name: this.currentUser.last_name,
            phone: this.currentUser.phone,
            email: this.currentUser.email
          })
          .then(response => {
            if (response.status === 200){
              this.isCurrentUserChanged = false
              console.log("Update Personal Date Success: ", response)
              this.testNotification(
                  'success',
                  this.$t('Successfully'),
                  this.$t('YourPersonalDataHasBeenUpdated')
              )
              if (this.$route.query.next){
                if (this.$route.query.next === "/shop/cart/"){
                  this.$swal.fire({
                    title: this.$t('toTheBasket'),
                    text: this.$t('doYouWantToReturnToTheBasketAndContinueTheOrder'),
                    icon: "question",
                    showDenyButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: this.$t('Yes'),
                    denyButtonText: this.$t('No')
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.assign(this.$route.query.next)
                    } else if (result.isDenied) {
                      this.$router.push({name: 'profile'})
                    }
                  });
                }
              }
            }else{
              if (response.data.errors !== undefined){
                if (response.data.errors.code === "client_email_already_use"){
                  this.isEmailInvalid = true;
                  this.emailMsg = response.data.errors.message;
                  this.testNotification(
                    'error',
                    this.$t('Email'),
                    response.data.errors.message
                  )
                } else if (response.data.errors.phone !== undefined){
                  if (response.data.errors.phone[0].code === "unique"){
                    this.isPhoneInvalid = true;
                    this.phoneMsg = this.$t('ThisPhoneNumberIsAlreadyInUse');
                    this.testNotification(
                      'error',
                      this.$t('Phone'),
                      this.$t('ThisPhoneNumberIsAlreadyInUse')
                    )
                  }
                }
              }
              if (response.data.phone !== undefined){
                this.phoneMsg = response.data.phone[0]
                this.isPhoneInvalid = true
              }
              if (response.data.email !== undefined){
                this.emailMsg = response.data.email[0]
                this.isEmailInvalid = true
              }
              if (response.data.first_name !== undefined){
                this.firstNameMsg = response.data.first_name[0]
                this.isFirstNameInvalid = true
              }
              if (response.data.last_name !== undefined){
                this.lastNameMsg = response.data.last_name[0]
                this.isLastNameInvalid = true
              }
            }
          })
    },
    onSubmitSetPassword(){
      this.restoreSetPassword();
      this.$store
          .dispatch(actionTypes.setPassword, {
            password: this.password,
            password_confirm: this.password_confirm,
          })
          .then(response => {
            if (response.status === 200){
              this.isCurrentUserChanged = false
              this.clearSetPassword();
              console.log("Set Password Success: ", response)
              this.testNotification(
                  'success',
                  this.$t('Successfully'),
                  this.$t('YourPersonalDataHasBeenUpdated')
              )
            }else{
              if (response.data.errors !== undefined){
                if (response.data.errors.code){
                  this.isPasswordInvalid = true;
                  this.passwordMsg = response.data.errors.message;
                  this.testNotification(
                    'error',
                    this.$t('Password'),
                    response.data.errors.message
                  )
                } else {
                  if (response.data.errors.password !== undefined){
                    this.passwordMsg = response.data.errors.password[0].message
                    this.isPasswordInvalid = true
                  }
                  if (response.data.errors.password_confirm !== undefined){
                    this.passwordMsg = response.data.errors.password_confirm[0].message
                    this.isPasswordInvalid = true
                  }
                }
              }
            }
          })
    },
    onSubmitLanguage(){
      this.lang = this.language
      this.$router.go(0)
    },
    testNotification(type, title, text){
      this.$notify({
        group: 'main',
        title: title,
        text: text,
        type: type,
        duration: 7000
      });
    },
    restoreCurrentUserData(){
      this.isCurrentUserChanged = false
      this.$store.dispatch(actionTypes.getCurrentUser)

      this.phoneMsg = '';
      this.emailMsg = '';
      this.firstNameMsg = '';
      this.lastNameMsg = '';
    },
    restoreSetPassword(){
      this.isPasswordInvalid = false;
      this.passwordMsg = '';
    },
    clearSetPassword(){
      this.password = '';
      this.password_confirm = '';
      this.isPasswordInvalid = false;
      this.passwordMsg = '';
    },
    onEmailChanged() {
      this.isEmailSaved = false
    }
  },
  computed: {
    ...mapGetters({
      isLoading: getterTypes.isLoading,
      isLoggedIn: getterTypes.isLoggedIn,
      currentUser: getterTypes.currentUser,
    }),
    first_name: {
      get(){
        return this.$store.state.auth.currentUser ? this.$store.state.auth.currentUser.first_name : ''
      },
      set(value){
        if (this.$store.state.auth.currentUser){
          this.$store.commit(mutationTypes.updateFirstName, value)
          this.isCurrentUserChanged = true
        }
      }
    },
    last_name: {
      get(){
        return this.$store.state.auth.currentUser ? this.$store.state.auth.currentUser.last_name : ''
      },
      set(value){
        if (this.$store.state.auth.currentUser){
          this.$store.commit(mutationTypes.updateLastName, value)
          this.isCurrentUserChanged = true
        }
      }
    },
    phone: {
      get(){
        let phone = this.$store.state.auth.currentUser ? this.$store.state.auth.currentUser.phone : '';
        if (phone === null) {
          return '';
        }
        return phone.replace(/^.{2}/g, '');
      },
      set(value){
        if (this.$store.state.auth.currentUser){
          this.$store.commit(mutationTypes.updatePhone, phoneCleanForSet(value))
          this.isCurrentUserChanged = true
        }
      }
    },
    phoneClean(){
      let phone = ''
      let phoneItems = this.phone.match(/[0-9]+/g)
      if (phoneItems === null) {
        return ''
      }
      phoneItems.forEach(function(i) {
        phone += i;
      })
      return phone
    },
    email: {
      get(){
        return this.$store.state.auth.currentUser ? this.$store.state.auth.currentUser.email : '';
      },
      set(value){
        if (this.$store.state.auth.currentUser){
          this.$store.commit(mutationTypes.updateEmail, value)
          this.isCurrentUserChanged = true
        }
      }
    },
    lang: {
      get(){
        console.log(getItem('lang'))
        return getItem('lang')
      },
      set(value){
        setItem('lang', value)
      }
    },
  },
  watch: {
    currentUser: {
      handler(newUser) {
        if (newUser?.email?.length > 0) {
          this.isEmailSaved = true
        } else {
          this.isEmailSaved = false
        }
      },
      immediate: true,
      deep: true
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";
  @import "@/scss/mixins.scss";

  .form-label{
    font-size: 12px;
    color: $fi;
  }

  .personal-section{
    margin-bottom: 8px;
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    &__header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px;
      cursor: pointer;
      outline: none;
      &__icon{
        margin-right: 24px;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }
      &__label{
        flex-grow: 1;
        margin-right: 16px;
        font-size: 18px;
        color: $fd;
        @media only screen and (max-width: $max-width-small) {
          font-size: 12px;
        }
      }
    }
    &__body{
      padding: 20px 20px 40px 20px;
      button{
        margin-right: 15px;
        margin-bottom: 10px;
      }
    }
  }
</style>
